module.exports = __webpack_public_path__ + "img/notice.6e8e51bf.svg";